import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { TranslocoLoader } from '@jsverse/transloco'

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient)

  getTranslation(lang: string) {
    return this.http.get(`/assets/i18n/${lang}.json`) // freshness handled by service worker dataGroup in ngsw-config
  }
}
